import { Component, Output, Input, EventEmitter } from "@angular/core";

@Component({
  selector: "upsell-cta",
  templateUrl: "upsell-cta.html",
  styleUrls: ["upsell-cta.scss"]
})

export class UpsellCTAComponent {

  @Input() buttonYesText: string = '';
  @Input() buttonNoText: string = '';
  @Input() upsellCtaTextButtonsClass: string;

  //Provide external method to navigate to next page over funnel
  @Output() eventEmitter: EventEmitter<boolean> = new EventEmitter();

  buttonValue: boolean = false;

  constructor() {}

  nextPage(buttonValue: boolean) {
    this.buttonValue = buttonValue ? true : false;
    this.eventEmitter.emit(this.buttonValue);
  }
}
